import { render } from "./SymptomsSummarySection.vue?vue&type=template&id=172ad26e"
import script from "./SymptomsSummarySection.vue?vue&type=script&lang=js"
export * from "./SymptomsSummarySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__